import * as React from 'react';
import cx from 'classnames';
import { createSvgIcon } from '../utils/createSvgIcon';
import { iconClassNames } from '../utils/iconClassNames';

export const FilesErrorIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg
      style={{ overflow: 'visible' }}
      role="presentation"
      focusable="false"
      viewBox="2 2 16 16"
      className={classes.svg}
    >
      <g className={cx(iconClassNames.outline, classes.outlinePart)}>
        <path d="M6 2C4.89543 2 4 2.89543 4 4V9.20703C4.32228 9.11588 4.65659 9.05337 5 9.02242V4C5 3.44772 5.44772 3 6 3H10V6.5C10 7.32843 10.6716 8 11.5 8H15V16C15 16.5523 14.5523 17 14 17H10.4003C10.2174 17.3578 9.99647 17.6929 9.74284 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 7.01639 15.842 6.63486 15.5607 6.35355L11.6464 2.43934C11.3651 2.15804 10.9836 2 10.5858 2H6ZM14.7929 7H11.5C11.2239 7 11 6.77614 11 6.5V3.20711L14.7929 7Z" />
        <path d="M10 14.5C10 16.9853 7.98528 19 5.5 19C3.01472 19 1 16.9853 1 14.5C1 12.0147 3.01472 10 5.5 10C7.98528 10 10 12.0147 10 14.5ZM5.5 12C5.22386 12 5 12.2239 5 12.5V14.5C5 14.7761 5.22386 15 5.5 15C5.77614 15 6 14.7761 6 14.5V12.5C6 12.2239 5.77614 12 5.5 12ZM5.5 17.125C5.84518 17.125 6.125 16.8452 6.125 16.5C6.125 16.1548 5.84518 15.875 5.5 15.875C5.15482 15.875 4.875 16.1548 4.875 16.5C4.875 16.8452 5.15482 17.125 5.5 17.125Z" />
      </g>

      <g className={cx(iconClassNames.filled, classes.filledPart)}>
        <path d="M10 2V6.5C10 7.32843 10.6716 8 11.5 8H16V16.5C16 17.3284 15.3284 18 14.5 18H9.74284C10.5282 17.0491 11 15.8296 11 14.5C11 11.4624 8.53757 9 5.5 9C4.97999 9 4.47683 9.07217 4 9.20703V3.5C4 2.67157 4.67157 2 5.5 2H10Z" />
        <path d="M11 2.25V6.5C11 6.77614 11.2239 7 11.5 7H15.75L11 2.25Z" />
        <path d="M10 14.5C10 16.9853 7.98528 19 5.5 19C3.01472 19 1 16.9853 1 14.5C1 12.0147 3.01472 10 5.5 10C7.98528 10 10 12.0147 10 14.5ZM5.5 12C5.22386 12 5 12.2239 5 12.5V14.5C5 14.7761 5.22386 15 5.5 15C5.77614 15 6 14.7761 6 14.5V12.5C6 12.2239 5.77614 12 5.5 12ZM5.5 17.125C5.84518 17.125 6.125 16.8452 6.125 16.5C6.125 16.1548 5.84518 15.875 5.5 15.875C5.15482 15.875 4.875 16.1548 4.875 16.5C4.875 16.8452 5.15482 17.125 5.5 17.125Z" />
      </g>
    </svg>
  ),
  displayName: 'FilesErrorIcon',
});
